import React from "react";

export const TransHyperlink = ({ url, target, rel, children, className }) => (
  <a href={url} target={target} rel={rel} className={className}>
    {children}
  </a>
);
